import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=11480b1c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=11480b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11480b1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11480b1c')) {
      api.createRecord('11480b1c', component.options)
    } else {
      api.reload('11480b1c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=11480b1c&scoped=true&", function () {
      api.rerender('11480b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sOpPeBDeLKWt/JS/comp/PopupBox.vue"
export default component.exports